import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function editFeatureNotification(notificationData) {
  try {
    const response = await axiosInstance.post('/feature-notifications/update-feature-notifications', notificationData);
    return response.data;
  } catch (error) {
    console.error('Edit Notification Error:', error);
    throw error;
  }
}
